import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { TestimonialCard } from '../TestimonialCard';
import { SectionHeading } from './SectionHeading';
import type { Testimonial } from '../../data/testimonials';

/**
 * BLOCK: testimonials_grid
 * ACF layout name: `block_testimonials_grid`
 *
 * Fields:
 *  - eyebrow      (text)
 *  - heading      (text)
 *  - testimonials (relationship → Testimonial CPT; empty = all)
 *  - cta          (group: label, link — optional)
 *
 * Used on: Home ("Thoughts from those who have walked this path.").
 */

interface TestimonialsGridProps {
  eyebrow?: string;
  heading: string;
  testimonials: readonly Testimonial[];
  ctaLabel?: string;
  ctaTo?: string;
}
export function TestimonialsGrid({
  eyebrow,
  heading,
  testimonials,
  ctaLabel,
  ctaTo
}: TestimonialsGridProps) {
  return <div className="mx-auto max-w-7xl" data-id="element-207" data-mp="z101aupux2nu">
      <SectionHeading eyebrow={eyebrow} heading={heading} align="center" className="mb-14" data-id="element-208" data-mp="yzylkcxwbrzs" />

      <div className="grid grid-cols-1 gap-8 md:grid-cols-2" data-id="element-209" data-mp="a5qu7d3jfw87">
        {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.45,
        delay: index * 0.06
      }} data-id="element-210" data-mp="nxne4tv1yzti" data-mpi={index}>
            <TestimonialCard testimonial={testimonial} data-id="element-211" data-mp="3nc8zgzi5zqkp" />
          </motion.div>)}
      </div>

      {ctaLabel && ctaTo && <div className="mt-10 text-center" data-id="element-212" data-mp="56w8a2a9xrjv">
          <Link to={ctaTo} className="group inline-flex items-center gap-3 text-xs font-medium tracking-[0.16em] text-sage-700 uppercase transition-colors hover:text-charcoal focus:outline-none focus:ring-2 focus:ring-sage-700 focus:ring-offset-4" data-id="element-213" data-mp="54jhczmjg6uo">
            {ctaLabel}
            <ArrowRight size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-214" data-mp="1bp2l4zxry5b3" />
          </Link>
        </div>}
    </div>;
}